import { Component } from '@rhtml/component';
import { css, html, LitElement, property } from '@rxdi/lit-html';

const profilePicture = new URL('../../navbar/picture.svg', import.meta.url).href;

/**
 * @customElement profile-icon
 *  */
@Component({
  Settings: {
    selector: 'profile-icon',
    styles: [
      css`
        .image {
          border-radius: 50%;
          width: 30px;
          height: 30px;
          border: 2px solid var(--menu-profile-border-color, #949494);
        }
      `,
    ],
  },
  Render: () =>
    function (this: ProfileIconComponent) {
      return html`
        ${this.src
          ? html`
              <div style="display: flex">
                <div>
                  <span class="flex: 1 3 auto;"></span>
                  <div>
                    <img class="image" src=${this.src} />
                  </div>
                </div>
              </div>
            `
          : html` <img class="image" src="${profilePicture}" /> `}
      `;
    },
})
export class ProfileIconComponent extends LitElement {
  @property({ type: String })
  public src: string;
}
